<template>
  <div class="row" v-if="prestacoes.length">
    <div class="col-xs-12">
      <h4>{{ title }}</h4>
    </div>
    <div class="col-xs-12">
      <ul>
        <li v-for="(prest, index) in prestacoes" :key="`pres-${index}`">
          <router-link
            v-if="statusHomologada(prest)"
            :to="{
              name: 'prestacao_detalhe',
              params: { codigo: prest.codigo, prestacao: prest, entidade }
            }"
          >
            {{
              `${prest.objeto_parceria} - Vigência (de ${new Date(
                `${prest.inicio_periodo} 00:00`
              ).toLocaleDateString()} até ${new Date(
                `${prest.fim_periodo} 00:00`
              ).toLocaleDateString()})`
            }}
          </router-link>
          <span v-else>
            {{
              `${prest.objeto_parceria} - Vigência (de ${new Date(
                `${prest.inicio_periodo} 00:00`
              ).toLocaleDateString()} até ${new Date(
                `${prest.fim_periodo} 00:00`
              ).toLocaleDateString()}) - `
            }}
            <span class="status">
              Em {{ prest.status_prestacao.descricao.toLowerCase() }}
            </span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListaPrestacoes',
  props: {
    title: {
      type: String,
      required: true
    },
    prestacoes: {
      type: Array,
      default: () => []
    },
    entidade: {
      type: Object,
      required: true
    }
  },
  methods: {
    statusHomologada(prestacao) {
      return prestacao.status_prestacao
        ? prestacao.status_prestacao.codigo === 3
        : false
    }
  }
}
</script>

<style scoped>
ul {
  font-size: 1.2em;
}
.status {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/PrestacaoContas/ListaPrestacoes.vue